// 音声で回答できない端末への案内 (spec: docs/superpowers/specs/2026-08-04-unsupported-device-notice-design.md §3.4)。
//
// 表示専用。押せるものを 1 つも置かないのは、行き止まりであることを画面の形で示すため
// (spec D1 / D5)。ボタンやステップ表示が見えていると「進めば直る」と読まれ、音声で
// 答えられないまま回答が始まってしまう。
//
// 読み上げない (spec D5)。iOS ではユーザー操作のコールスタック内でしか音が鳴らず
// (計測ノート 2026-08-04 §2.2 の T2)、押すものが無いこの画面では鳴らす契機が作れない。
//
// 理由 (SIMD 非対応 / WebKit 16.4) で文言を出し分けないのは、取るべき行動が同じだから。
// バージョン番号を画面に出さないのは、機能検出だけで弾いた場合に UA からバージョンを
// 読めておらず、「お使いの iOS は 15.8 です」のような断定ができないため。
export function UnsupportedDevice() {
  return (
    <div className="mx-auto w-full max-w-2xl flex flex-col flex-1 min-h-0 bg-slate-50 overflow-y-auto">
      <div className="flex-1 px-6 py-10 flex flex-col items-center justify-center text-center">
        <div
          className="w-16 h-16 rounded-full bg-amber-50 border border-amber-300 grid place-items-center text-3xl font-bold text-amber-800 mb-5"
          aria-hidden="true"
        >
          !
        </div>
        <h1 className="text-[17px] font-bold text-slate-900 mb-4">この端末では回答できません</h1>
        <p className="text-[13px] leading-relaxed text-slate-700">
          このアンケートは音声でお答えいただくものですが、
          <br />
          お使いのブラウザでは音声の聞き取り機能が動きません。
        </p>
        <div className="w-full text-left bg-white border border-slate-200 rounded-lg px-4 py-3.5 my-5 flex flex-col gap-3">
          <div className="flex gap-2.5 items-start">
            <span className="shrink-0 w-[84px] text-xs font-bold text-slate-900 leading-relaxed">
              iPhone・iPad
            </span>
            <span className="text-xs text-slate-700 leading-relaxed">
              iOS を 16.5 以上に更新してから、Safari でお開きください。
            </span>
          </div>
          <div className="flex gap-2.5 items-start">
            <span className="shrink-0 w-[84px] text-xs font-bold text-slate-900 leading-relaxed">
              パソコン
            </span>
            <span className="text-xs text-slate-700 leading-relaxed">
              Chrome・Edge・Safari の最新版でお開きください。
            </span>
          </div>
        </div>
        <p className="text-xs text-slate-500 leading-relaxed">
          更新後は、このページを再読み込みしてください。
        </p>
      </div>
    </div>
  );
}
